<template>
  <Timeline
    :timeline="timeline"
    :statuses="statuses"
    :permissions="timelinePermissions"
    @save="saveTimeline"
    @remove="deleteTimelineStep"
  />
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';

  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import Utils from '@/common/utils';

  import Timeline from '@/components/timeline/Timeline.vue';

  import {
    INITIATIVE_REGISTRY_GETTERS_NAME,
    INITIATIVE_REGISTRY_MUTATIONS_NAME,
  } from '@/modules/measure/store/initiativeRegistry/name';

  import NsiApi from '../../../nsi/api/nsi';
  import Api from '../../api/reqsinitiativesttr';

  const PERMISSIONS = {
    addTimeline: Constants.Permissions.RequestInitiativeTtrAddTimeline,
    editTimeline: Constants.Permissions.RequestInitiativeTtrEditTimeline,
    deleteTimeline: Constants.Permissions.RequestInitiativeTtrDeleteTimeline,
  };

  export default {
    name: 'InitiativeTimeline',
    components: {
      Timeline,
    },
    mixins: [security],
    data: function () {
      return {
        timeline: [],
        statuses: [],
        exportMeasureIds: [1, 2],
        importMeasureIds: [3, 4, 5, 6],
        timelinePermissions: {
          add: false,
          edit: false,
          delete: false,
        },
      };
    },
    computed: {
      ...mapGetters({
        getInitiative: INITIATIVE_REGISTRY_GETTERS_NAME.getInitiative,
      }),
    },
    created() {
      this.loadStatuses();
      this.loadPermissions();
    },
    methods: {
      ...mapMutations({
        setTimeline: INITIATIVE_REGISTRY_MUTATIONS_NAME.setTimeline,
      }),
      async loadPermissions() {
        const [addResponse, editResponse, deleteResponse] = await Promise.all([
          this.checkPermission(PERMISSIONS.addTimeline),
          this.checkPermission(PERMISSIONS.editTimeline),
          this.checkPermission(PERMISSIONS.deleteTimeline),
        ]);
        this.timelinePermissions = {
          add: Boolean(addResponse.data),
          edit: Boolean(editResponse.data),
          delete: Boolean(deleteResponse.data),
        };
      },
      async saveTimeline(item) {
        if (item.id) {
          if (!this.timelinePermissions.edit) {
            this.notAccess();
            return;
          }
          await this.updateTimeline(item);
        } else {
          if (!this.timelinePermissions.add) {
            this.notAccess();
            return;
          }
          await this.createTimeline(item);
        }

        this.setTimeline(this.timeline);
      },
      async updateTimeline(updatedItem) {
        try {
          await Api.updateTimeline(this.getInitiative.id, updatedItem);
          const index = this.timeline.findIndex((x) => x.id === updatedItem.id);
          this.timeline.splice(index, 1, updatedItem);
        } catch (err) {
          Constants.alert.fire('Добавление шага', Constants.commonError, 'error');
          console.error(err?.response?.data);
        }
      },
      async createTimeline(item) {
        try {
          const response = await Api.addTimeline(this.getInitiative.id, item);
          this.timeline.push(response.data);
        } catch (err) {
          Constants.alert.fire('Добавление шага', Constants.commonError, 'error');
          console.error(err?.response?.data);
        }
      },
      async deleteTimelineStep(data) {
        if (!this.timelinePermissions.delete) {
          this.notAccess();
          return;
        }
        const response = await Constants.alert.fire(Constants.confirmOptions.delete);

        if (response.isConfirmed) {
          try {
            await Api.deleteTimeline(this.getInitiative.id, data.item.id);
            this.timeline.splice(data.index, 1);
          } catch (err) {
            Constants.alert.fire('Удаление шага', Constants.commonError, 'error');
            console.error(err?.response?.data);
          }
        }
      },
      async loadStatuses() {
        try {
          const request = { pageNumber: 1, pageSize: 0 };
          if (this.exportMeasureIds.includes(this.getInitiative.measureTypeId))
            request.tradingOperationId = Constants.tradingOperation.export;
          else if (this.importMeasureIds.includes(this.getInitiative.measureTypeId))
            request.tradingOperationId = Constants.tradingOperation.import;
          const response = await NsiApi.search('nsirequestttrstatus', request);

          this.statuses = Utils.groupList(response.data.items, (x) => ({
            id: x.tradingOperationId,
            text: x.tradingOperation.name,
          }));
        } catch (err) {
          console.error(err.response.data);
        }
      },
    },
    watch: {
      getInitiative: {
        handler(newValue) {
          this.timeline = newValue.timeline;
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .comment-text {
    white-space: pre;
  }
</style>
